import { render, staticRenderFns } from "./toi_upload.vue?vue&type=template&id=6f416950&"
import script from "./toi_upload.vue?vue&type=script&lang=js&"
export * from "./toi_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports